import ProductCard from "components/Product";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import styled from "styled-components/macro";
import { selectIsLoading, selectReelProducts } from "./productReelSlice";
import ProductCardSkeleton from "components/Product/ProductCardSkeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

SwiperCore.use([Autoplay]);

export const PRODUCT_REEL_AUTOPLAY_DELAY = 8000;
export const PRODUCT_REEL_TRANSITION_SPEED = 650;

const ProductsInReel: React.FC = () => {
  const products = useSelector((state: RootState) => selectReelProducts(state));
  const isLoading = useSelector((state: RootState) => selectIsLoading(state));

  return (
    <ProductsInReelContainer>
      <Reel>
        <ProductsContainer aria-busy={isLoading}>
          {isLoading && (
            <LoadingStatus role="status">Зареждане на продукти</LoadingStatus>
          )}
          <Swiper
            style={{ padding: "18px 4px 28px" }}
            spaceBetween={16}
            breakpoints={{
              1: {
                slidesPerView: 1,
                slidesPerGroup: 1,
              },
              600: {
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
              900: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              1280: {
                slidesPerView: 4,
                slidesPerGroup: 4,
              },
            }}
            speed={PRODUCT_REEL_TRANSITION_SPEED}
            autoplay={
              isLoading
                ? false
                : {
                    delay: PRODUCT_REEL_AUTOPLAY_DELAY,
                    disableOnInteraction: true,
                  }
            }
            loop={!isLoading}
          >
            {isLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                  <SwiperSlide key={`reel-skeleton-${index}`}>
                    <ProductCardSkeleton />
                  </SwiperSlide>
                ))
              : products?.map((product) => (
                  <SwiperSlide key={product._id}>
                    <ProductCard item={product} />
                  </SwiperSlide>
                ))}
          </Swiper>
        </ProductsContainer>
      </Reel>
    </ProductsInReelContainer>
  );
};

const ProductsInReelContainer = styled.div`
  width: 100%;
  min-width: 0;
  padding: 8px 12px;
  box-sizing: border-box;
`;

const Reel = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  justify-content: center;

  .hide {
    opacity: 0;
  }
`;
Reel.displayName = "Reel";

const ProductsContainer = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 1500px;

  ::-webkit-scrollbar {
    /* Hide scrollbar for Chrome, Safari and Opera */
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  .swiper-slide {
    display: flex;
    height: auto;
  }

  .swiper-slide > * {
    width: 100%;
  }
`;
ProductsContainer.displayName = "ProductsContainer";

const LoadingStatus = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export default memo(ProductsInReel);
